import React from 'react';

import { useIntl } from 'react-intl-next';

import PageHeader from '@atlaskit/page-header';
import { useIsNewNavigation } from '@atlassian/eoc-global-context';

import messages from './messages';
import { type HeaderProps } from './types';

export const Header: React.FC<HeaderProps> = ({ bottomBar, actionButtons, breadcrumbs }) => {
	const { formatMessage } = useIntl();

	const isHorizontalNav = useIsNewNavigation();

	return (
		<>
			<PageHeader
				breadcrumbs={!isHorizontalNav ? breadcrumbs : <></>}
				actions={actionButtons}
				bottomBar={bottomBar}
			>
				{!isHorizontalNav && formatMessage(messages.title)}
			</PageHeader>
		</>
	);
};
